// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2zy8c","fileBtn":"File_fileBtn__2ABlV","closeBtn":"File_closeBtn__3a5-S","fileSelected":"File_fileSelected__20RP-","disabled":"File_disabled__2GV2Y"};